import { motion } from "framer-motion";
import { ArrowRight, Shield } from "lucide-react";
import { Button } from "../components/ui/button";

const HERO_BG = "https://static.prod-images.emergentagent.com/jobs/3bee16da-1518-4ecf-84ec-23daebfe4616/images/62f6dd28ed9faafce4371769089969d47f4d725afd5ebbdd201762289ef3b197.png";

export default function Hero() {
  return (
    <section
      id="hero"
      data-testid="hero-section"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src={HERO_BG}
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="hero-overlay absolute inset-0" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12 lg:px-24 pt-32 pb-20">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="max-w-3xl"
        >
          {/* Overline */}
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            className="flex items-center gap-3 mb-8"
          >
            <Shield className="w-4 h-4 text-[#B87333]" />
            <span className="text-xs uppercase tracking-[0.2em] font-semibold text-[#E5A97A]/80">
              Secure &bull; Comply &bull; Grow
            </span>
          </motion.div>

          {/* Heading */}
          <motion.h1
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.7 }}
            className="text-4xl sm:text-5xl lg:text-6xl tracking-tighter font-semibold text-white leading-[1.1] mb-6"
          >
            Fractional Security Leadership for the{" "}
            <span className="text-[#B87333]">Modern Enterprise</span>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.7 }}
            className="text-base md:text-lg text-zinc-400 leading-relaxed mb-10 max-w-2xl"
          >
            Expert guidance across compliance, cloud security, and AI risk —
            fortifying your business without the overhead of a full-time
            security team.
          </motion.p>

          {/* CTAs */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.7, duration: 0.6 }}
            className="flex flex-col sm:flex-row gap-4"
          >
            <a href="#contact">
              <Button
                data-testid="hero-cta-primary"
                className="bg-[#B87333] hover:bg-[#A6632B] text-white rounded-md px-6 py-3 text-sm font-medium transition-all group"
              >
                Get a Security Assessment
                <ArrowRight className="w-4 h-4 ml-1 group-hover:translate-x-1 transition-transform" />
              </Button>
            </a>
            <a href="#services">
              <Button
                data-testid="hero-cta-secondary"
                variant="outline"
                className="border-white/20 hover:border-white/50 text-white rounded-md px-6 py-3 text-sm font-medium transition-all"
              >
                Explore Services
              </Button>
            </a>
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
}
